import { UserData } from "../../entities/app-data/UserData";
import { Token } from "../../entities/app-data/Token";
import routeNames from "../../router/route-names";
import { getSpentTokens, getOrderLines } from "../../utils/TransactionUtils";
import {
  Transaction,
  transactionTypes,
} from "../../entities/app-data/Transaction";

const state = {
  userData: null,
  transactions: null,
  editData: {},
  eventTokens: null,
};

const getters = {
  eventTokens: (state) => state.eventTokens,
};

const actions = {
  getTokens: ({ state }, router) => {
    if (state.userData && state.userData.tokens) {
      return state.userData.tokens;
    } else {
      router.push({ name: routeNames.WALLET });
    }
  },
  setUserData: ({ state, dispatch }, { context, userData }) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: false })
        .then((customization) => {
          state.eventTokens = customization.tokens;
          var tokens = userData.tokens.map((token) => {
            var tokenData = customization.tokens.find((t) => {
              return t.id === token.token;
            });
            if (tokenData == null) {
              tokenData = {
                name: "ID: " + token.token,
                icon: "local_play",
              };
            }
            return new Token(
              token.token,
              tokenData.name,
              tokenData.icon,
              token.amount
            );
          });
          userData.category = customization.categories.find((category) => {
            return parseInt(category.id) === parseInt(userData.category);
          });
          state.userData = new UserData(
            userData.id,
            userData.tag_id,
            userData.locator,
            userData.email,
            userData.balance,
            userData.refundable_balance || userData.refundableBalance,
            tokens,
            userData.blacklisted,
            userData.category,
            userData.name,
            userData.surname,
            userData.gender,
            userData.birthday,
            userData.phone_number,
            userData.country,
            userData.document,
            userData.public_seed
          );
          resolve(state.userData);
        })
        .catch((error) => reject(error));
    });
  },
  setTransactions: ({ state, dispatch }, { context, transactions }) => {
    return new Promise((resolve, reject) => {
      dispatch("getCustomization", { context, getSaved: false })
        .then((customization) => {
          var transactionsMapped = transactions.map((transaction) => {
            var token = null;
            var spentTokens = null;
            var orderLines = null;
            if (transaction.origin != null) {
              var foundOrigin = customization.stations.find((station) => {
                return station.id.toString() === transaction.origin;
              });
              if (foundOrigin != null) {
                transaction.origin = foundOrigin.name;
              } else if (transaction.origin != null) {
                transaction.origin =
                  context.$t("transactions.station") + " " + transaction.origin;
              }
            }
            switch (transaction.type) {
              case transactionTypes.ORDER:
                orderLines = getOrderLines(
                  transaction,
                  customization.products,
                  customization.tokens
                );
                spentTokens = getSpentTokens(orderLines);
                break;
              case transactionTypes.TOKEN:
                token = customization.tokens.find((token) => {
                  return token.id === transaction.token;
                });
                break;
            }
            return new Transaction(
              transaction,
              orderLines,
              token,
              spentTokens,
              context
            );
          });
          state.transactions = transactionsMapped;
          resolve(state.transactions);
        })
        .catch((error) => reject(error));
    });
  },
};

const mutations = {
  setField(state, { field, value }) {
    state.editData[field] = value;
  },
  resetEditData(state) {
    state.editData = {};
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
